import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorType } from 'src/app/core/routing/error-types';
import { ShowInactiveService } from 'src/app/base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from 'src/app/base/shared/syncfusion/adaptor-service.interface';
import { ToastService } from 'src/app/base/services/toast.service';
import {
  FilterDTO,
  IPagedResultDTOOfSamplingProfileConfigDTO,
  SamplingProfileClient,
  SortDirection,
} from 'src/app/base/models/models.swagger.generated';

/**
 * Read-only lookup over the sampling profile catalog, backing the profile picker in the vehicle
 * assign dialog. Distinct from `SamplingProfilesService`, which owns the mutating profile CRUD.
 */
@Injectable()
export class SamplingProfileLookupService extends ShowInactiveService implements IAdaptorService {

  constructor(
    private samplingProfileClient: SamplingProfileClient,
    private toastService: ToastService,
  ) {
    super();
  }

  public getData(
    skip: number,
    take: number,
    filters: FilterDTO[],
    sortBy: string | undefined,
    sortDirection: SortDirection | undefined,
  ): Observable<IPagedResultDTOOfSamplingProfileConfigDTO | null> {
    return this.samplingProfileClient.searchSamplingProfiles(filters, skip, take, sortBy, sortDirection)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', '', ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public addRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the sampling profile catalog is read-only here.'));
  }

  public updateRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the sampling profile catalog is read-only here.'));
  }

  public deleteRecord(): Observable<any> {
    return throwError(() => new Error('Not supported: the sampling profile catalog is read-only here.'));
  }
}
